(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asiri-collection-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__asiriCollectionCards) return;
    window.__asiriCollectionCards = true;

    function isDesktop() {
      return window.innerWidth >= 1024;
    }

    function previewOf(card) {
      return card ? card.querySelector('.acc-card__preview video') : null;
    }

    function playerOf(card) {
      return card ? card.querySelector('.acc-card__player video') : null;
    }

    function safePlay(video) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function rewind(video) {
      try { video.currentTime = 0; } catch (e) {}
    }

    // As in the reference: measure the real text / feature heights so the
    // max-height transitions run on exact values.
    function measure(card) {
      var text = card.querySelector('.acc-card__text-wrap');
      var features = card.querySelector('.acc-card__features-wrap');
      if (text) card.style.setProperty('--text-height', text.scrollHeight + 'px');
      if (features) {
        var prev = features.style.maxHeight;
        features.style.maxHeight = 'none';
        card.style.setProperty('--features-height', features.scrollHeight + 'px');
        features.style.maxHeight = prev;
      }
    }

    function playPreview(card) {
      if (card.classList.contains('is-playing')) return;
      var video = previewOf(card);
      if (!video) return;
      video.muted = true;
      rewind(video);
      safePlay(video);
    }

    function pausePreview(card) {
      var video = previewOf(card);
      if (!video) return;
      video.pause();
      rewind(video);
    }

    function setExpanded(card, open) {
      card.classList.toggle('is-expanded', open);
      var plus = card.querySelector('.acc-card__plus');
      if (plus) plus.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) playPreview(card); else pausePreview(card);
    }

    function toggleExpand(card) {
      if (card.classList.contains('is-expanded')) {
        setExpanded(card, false);
        return;
      }
      document.querySelectorAll('.acc-card.is-expanded').forEach(function (other) {
        setExpanded(other, false);
      });
      setExpanded(card, true);
    }

    function closePlayer(card, restoreFocus) {
      var video = playerOf(card);
      card.classList.remove('is-playing');
      setExpanded(card, false);
      if (video) {
        video.pause();
        rewind(video);
      }
      if (restoreFocus) {
        var play = card.querySelector('button.acc-card__play');
        if (play) play.focus({ preventScroll: true });
      }
    }

    function openPlayer(card) {
      var video = playerOf(card);
      if (!video) return;
      document.querySelectorAll('.acc-card.is-playing').forEach(function (other) {
        if (other !== card) closePlayer(other, false);
      });
      pausePreview(card);
      card.classList.add('is-playing');
      rewind(video);
      safePlay(video);
      var close = card.querySelector('.acc-card__close');
      if (close) close.focus({ preventScroll: true });
    }

    // Arrows: disable at either end so they only show when there is more.
    function updateArrows(grid) {
      var viewport = grid.parentElement;
      var prev = viewport.querySelector('.acc__arrow--prev');
      var next = viewport.querySelector('.acc__arrow--next');
      if (!prev || !next) return;
      var max = grid.scrollWidth - grid.clientWidth;
      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft >= max - 2;
    }

    function step(grid, direction) {
      var card = grid.querySelector('.acc-card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
      grid.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    var observer = window.ResizeObserver ? new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.querySelectorAll('.acc-card').forEach(measure);
      });
    }) : null;

    function refresh() {
      document.querySelectorAll('.acc').forEach(function (section) {
        section.querySelectorAll('.acc-card').forEach(measure);
        if (observer && !section.__accObserved) {
          observer.observe(section);
          section.__accObserved = true;
        }
      });
      document.querySelectorAll('.acc__grid').forEach(updateArrows);
    }

    // Hover preview (mouseenter / mouseleave per card, via delegation).
    document.addEventListener('mouseover', function (event) {
      var card = event.target.closest && event.target.closest('.acc-card');
      if (!card || card.contains(event.relatedTarget)) return;
      playPreview(card);
    });

    document.addEventListener('mouseout', function (event) {
      var card = event.target.closest && event.target.closest('.acc-card');
      if (!card || card.contains(event.relatedTarget)) return;
      if (!card.classList.contains('is-expanded')) pausePreview(card);
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var arrow = event.target.closest('.acc__arrow');
      if (arrow) {
        step(arrow.parentElement.querySelector('.acc__grid'), arrow.classList.contains('acc__arrow--prev') ? -1 : 1);
        return;
      }

      var card = event.target.closest('.acc-card');
      if (!card) return;

      if (event.target.closest('button.acc-card__play')) {
        event.preventDefault();
        openPlayer(card);
        return;
      }
      if (event.target.closest('.acc-card__close')) {
        event.preventDefault();
        closePlayer(card, true);
        return;
      }
      if (event.target.closest('.acc-card__plus')) {
        event.preventDefault();
        toggleExpand(card);
        return;
      }
      if (event.target.closest('.acc-card__player') || event.target.closest('.acc-card__cta')) return;

      // Clicking the text area goes to the collection (on touch, once open).
      var content = event.target.closest('.acc-card__content');
      if (!content) return;
      if (isDesktop() || card.classList.contains('is-expanded')) {
        window.location.href = content.getAttribute('data-href');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var card = document.querySelector('.acc-card.is-playing');
      if (card) closePlayer(card, true);
    });

    // Scroll events don't bubble, so listen in the capture phase.
    document.addEventListener('scroll', function (event) {
      var grid = event.target;
      if (grid.classList && grid.classList.contains('acc__grid')) updateArrows(grid);
    }, true);

    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    document.addEventListener('shopify:section:load', refresh);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh);
    } else {
      refresh();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asiri-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__asiriFaqTabs) return;
    window.__asiriFaqTabs = true;

    function tabsOf(section) {
      return Array.prototype.slice.call(section.querySelectorAll('.afaq__tab'));
    }

    function selectTab(section, tab, focus) {
      tabsOf(section).forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-active', on);
      });
      if (focus) tab.focus();
    }

    function setOpen(button, open) {
      var answer = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (answer) answer.classList.toggle('is-open', open);
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var section = event.target.closest('[data-afaq]');
      if (!section) return;

      var tab = event.target.closest('.afaq__tab');
      if (tab) {
        selectTab(section, tab, false);
        return;
      }

      // One answer open at a time, as in the reference.
      var button = event.target.closest('.afaq__q-btn');
      if (button) {
        var opening = button.getAttribute('aria-expanded') !== 'true';
        section.querySelectorAll('.afaq__q-btn[aria-expanded="true"]').forEach(function (other) {
          if (other !== button) setOpen(other, false);
        });
        setOpen(button, opening);
      }
    });

    // Arrow keys, Home and End move between tabs (WAI-ARIA tabs pattern).
    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest && event.target.closest('.afaq__tab');
      if (!tab) return;
      var section = tab.closest('[data-afaq]');
      var tabs = tabsOf(section);
      var i = tabs.indexOf(tab);
      var next = null;
      if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      selectTab(section, next, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asiri-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__asiriProductTabs) return;
    window.__asiriProductTabs = true;

    function tabsOf(section) {
      return Array.prototype.slice.call(section.querySelectorAll('.aptab__tab'));
    }

    function selectTab(section, tab, focus) {
      tabsOf(section).forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-active', on);
      });
      if (focus) tab.focus();
    }

    function setOpen(button, open) {
      var answer = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (answer) answer.classList.toggle('is-open', open);
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var section = event.target.closest('[data-aptab]');
      if (!section) return;

      var tab = event.target.closest('.aptab__tab');
      if (tab) {
        selectTab(section, tab, false);
        return;
      }

      var button = event.target.closest('.aptab__q-btn');
      if (button) {
        var opening = button.getAttribute('aria-expanded') !== 'true';
        section.querySelectorAll('.aptab__q-btn[aria-expanded="true"]').forEach(function (other) {
          if (other !== button) setOpen(other, false);
        });
        setOpen(button, opening);
      }
    });

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest && event.target.closest('.aptab__tab');
      if (!tab) return;
      var section = tab.closest('[data-aptab]');
      var tabs = tabsOf(section);
      var i = tabs.indexOf(tab);
      var next = null;
      if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      selectTab(section, next, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
